import type { RedoMerchantSmsTemplatesRpcClient } from "@redotech/redo-merchant-sms-templates-rpc/client";
import { createRedoMerchantSmsTemplatesRpcClient } from "@redotech/redo-merchant-sms-templates-rpc/client";
import { Context, createContext, ReactNode, useMemo } from "react";

export const RedoMerchantSmsTemplatesRpcClientContext: Context<
  RedoMerchantSmsTemplatesRpcClient | undefined
> = createContext<RedoMerchantSmsTemplatesRpcClient | undefined>(undefined);
RedoMerchantSmsTemplatesRpcClientContext.displayName =
  "RedoMerchantSmsTemplatesRpcClientContext";

export function RedoMerchantSmsTemplatesRpcClientProvider({
  children,
  baseUrl,
  authToken,
}: {
  children: ReactNode | ReactNode[];
  baseUrl: string;
  authToken?: string;
}) {
  const client = useMemo(() => {
    if (!authToken) {
      return undefined;
    }
    return createRedoMerchantSmsTemplatesRpcClient({
      baseURL: new URL(`${baseUrl}/sms-templates-rpc`),
      headers: { Authorization: authToken },
    });
  }, [baseUrl, authToken]);
  return (
    <RedoMerchantSmsTemplatesRpcClientContext.Provider value={client}>
      {children}
    </RedoMerchantSmsTemplatesRpcClientContext.Provider>
  );
}
